module.exports = __webpack_public_path__ + "static/media/projects.3dd27a71.svg";